import { supabase } from '../supabaseClient';

export class TenantUrlHandler {
  static async detectTenant() {
    const hostname = window.location.hostname;
    
    try {
      console.log('Attempting cloud function lookup for:', hostname);
      const { data, error } = await supabase.functions.invoke('tenant-lookup', {
        headers: { 'host': hostname }
      });

      if (error) {
        console.log('Cloud function error:', error);
      } else if (data) {
        console.log('Cloud function success:', data);
        return {
          ...data.tenant,
          urlType: data.urlType,
          originalUrl: hostname
        };
      }
    } catch (error) {
      console.log('Cloud function failed:', error.message);
    }
    
    console.log('Falling back to local tenant lookup for:', hostname);

    // Handle localhost first
    if (hostname.includes('localhost')) {
      console.log('Localhost detected, looking for demo tenant');
      try {
        const { data: demoTenant, error } = await supabase
          .from('tenants')
          .select('*')
          .eq('domain', 'demo')
          .single();

        if (error) {
          console.log('Demo tenant query error:', error);
          return { domain: 'demo', urlType: 'localhost' };
        }

        console.log('Demo tenant found:', demoTenant);
        return {
          ...demoTenant,
          urlType: 'localhost',
          originalUrl: hostname
        };
      } catch (error) {
        console.log('Demo tenant lookup failed:', error);
        return { domain: 'demo', urlType: 'localhost' };
      }
    }

    // Try custom domain for non-localhost
    try {
      const { data: customDomainTenant } = await supabase
        .from('tenants')
        .select('*')
        .eq('custom_domain', hostname)
        .eq('custom_domain_verified', true)
        .single();

      if (customDomainTenant) {
        return { 
          ...customDomainTenant, 
          urlType: 'custom_domain',
          originalUrl: hostname 
        };
      }
    } catch (error) {
      // Continue to subdomain check
    }

    // Try subdomain extraction
    const parts = hostname.split('.');
    if (parts.length >= 3) {
      const subdomain = parts[0];
      
      try {
        const { data: subdomainTenant } = await supabase
          .from('tenants')
          .select('*')
          .eq('domain', subdomain)
          .eq('subdomain_enabled', true)
          .single();

        if (subdomainTenant) {
          return { 
            ...subdomainTenant, 
            urlType: 'subdomain',
            originalUrl: hostname 
          };
        }
      } catch (error) {
        // Continue to localhost check
      }
    }



    console.log('No tenant found for hostname:', hostname);
    return null;
  }

  static generateUrls(tenant) {
    const baseUrl = process.env.REACT_APP_BASE_URL || 'rpms.verexone.com';
    
    return {
      subdomain: tenant.subdomain_enabled ? `https://${tenant.domain}.${baseUrl}` : null,
      customDomain: tenant.custom_domain_verified ? `https://${tenant.custom_domain}` : null
    };
  }

  static async verifyCustomDomain(tenantId, domain) {
    try {
      // In production, this would verify DNS records
      const { data, error } = await supabase
        .from('tenants')
        .update({ 
          custom_domain: domain,
          custom_domain_verified: false // Requires manual verification
        })
        .eq('id', tenantId)
        .select();

      return { data, error };
    } catch (error) {
      return { data: null, error };
    }
  }
}